import { Resources } from 'constants/resources';

import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { ListContextProvider, ListControllerResult, useListController } from 'react-admin';
import { PageHeader } from 'shared/mui/PageHeader';

import { useGetOrderConversionChartData } from './hooks/useGetOrderConversionChartData';
import { OrderConversionChartContent } from './OrderConversionChartContent';

export const OrderConversionChart: React.FC = () => {
  const translate = useTypedTranslate();
  const { filterValues, ...restContext } = useListController({
    resource: Resources.OrderConversionChart,
    queryOptions: { enabled: false },
  });

  const { data, isLoading } = useGetOrderConversionChartData(filterValues);

  return (
    <ListContextProvider
      value={
        {
          filterValues,
          ...restContext,
          data: [data],
          isLoading,
        } as ListControllerResult
      }
    >
      <PageHeader
        headerTitle={{ titleText: translate('app.orderConversionCharts.orderGraphs') }}
        mt={3}
      />
      <OrderConversionChartContent />
    </ListContextProvider>
  );
};
